import React from 'react';

export default function Logo() {
  return (
    <></>
  );
}
